import React from "react";

import type { BreakpointIconId } from "@intelligems/ig-types";

import { LockClosedVersion1 } from "../../ProgressBarView/icons/LockClosedVersion1";
import { IconProps } from "../types";

import { Cart } from "./Cart";
import { CartAdd } from "./CartAdd";
import { Check } from "./Check";
import { Crown } from "./Crown";
import { Gift } from "./Gift";
import { Key } from "./Key";
import { Label } from "./Label";
import { Lightning } from "./Lightning";
import { LockClosed } from "./LockClosed";
import { LockOpen } from "./LockOpen";
import { Plus } from "./Plus";
import { SmileyDark } from "./SmileyDark";
import { SmileyLight } from "./SmileyLight";
import { Snowflake } from "./Snowflake";
import { Star } from "./Star";
import { Sun } from "./Sun";
import { ThumbsUp } from "./ThumbsUp";
import { Truck } from "./Truck";

export const ProgressBarIcon = ({
  id,
  ...props
}: IconProps & { id: BreakpointIconId }) => {
  switch (id) {
    case "cart":
      return <Cart {...props} />;
    case "cartAdd":
      return <CartAdd {...props} />;
    case "check":
      return <Check {...props} />;
    case "crown":
      return <Crown {...props} />;
    case "gift":
      return <Gift {...props} />;
    case "key":
      return <Key {...props} />;
    case "label":
      return <Label {...props} />;
    case "lightning":
      return <Lightning {...props} />;
    case "lockClosed":
      return <LockClosed {...props} />;
    case "lockClosedVersion1":
      return <LockClosedVersion1 {...props} />;
    case "lockOpen":
      return <LockOpen {...props} />;
    case "plus":
      return <Plus {...props} />;
    case "smileyDark":
      return <SmileyDark {...props} />;
    case "smileyLight":
      return <SmileyLight {...props} />;
    case "snowflake":
      return <Snowflake {...props} />;
    case "star":
      return <Star {...props} />;
    case "sun":
      return <Sun {...props} />;
    case "thumbsUp":
      return <ThumbsUp {...props} />;
    case "truck":
      return <Truck {...props} />;
  }
};
